<ng-container *ngIf="role && role !== 'MODERATOR'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>
<mat-spinner class="comeOnTop" *ngIf="pdfLoading"></mat-spinner>
<ng-container *ngIf="role && role === 'MODERATOR'">
  <div class="wrapper">
    <br>
    <div class="content">
      <ng-container *ngIf="customers">
        <div class="alert alert-danger" role="alert" *ngIf="customers.length === 0">
          No Customers
        </div>
        <div class="alert alert-primary" role="alert" *ngIf="customers.length !== 0">
          Available customers
        </div>
        <!-- Customer details -->
        <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <th>User Name</th>
                  <th>Full Name</th>
                  <th>email</th>
                  <th>Contact Details</th>
                  <!-- <th>Get Invoice</th> -->
                  <th>Filter date and get report</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let customer of customers">
                  <td>{{customer.userName}}</td>
                  <td>{{customer.fullName}}</td>
                  <td>{{customer.email}}</td>
                  <td>{{customer.contactNumber}}</td>
                  <!-- <td>
                    <button class="btn btn-lg btn-outline-primary" type="button" [disabled]='pdfLoading' (click)="sendInvoice(customer._id, customer.fullName)">Get Invoice</button>
                  </td> -->
                  <td><button class="btn btn-lg btn-outline-primary" (click)="open(mymodal, customer)">Generate Report</button></td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-template #mymodal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Select Date Range for Report</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="filterForm" (submit)="sendInvoiceDateFilter()">
        <mat-form-field id="formField" appearance="fill">
          <mat-label id="head">Select Date Range: 
            <mat-icon id="icon" matDatepickerToggleIcon (click)="clearDate($event)">clear</mat-icon>
          </mat-label>
         
          <mat-date-range-input [rangePicker]="picker" >
            <input formControlName="startDate" matStartDate placeholder="Start date" required>
            <input formControlName="endDate" matEndDate placeholder="End date" required>
            
          </mat-date-range-input>
          
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field><br>
        <button id="generate" type="submit">Generate Report</button>
      </form>
    </div>

  </ng-template>
</ng-container>
